/**
 * Подготавливает ВУ для формы водителя и API без запросов и изменения оригинала.
 * Пустая форма создания имеет свои defaults; незагруженные вложения при редактировании сохраняются.
 */
// Возвращает независимые начальные значения для нового ВУ.
export function createEmptyDriverLicense() {
  return {
    series: "",
    number: "",
    issued_at: "",
    valid_to: "",
    issued_by: "",
    categories: [],
    attachment_ids: [],
    attachments: [],
  };
}

// Нормализует даты и категории; null документа означает форму создания.
export function normalizeDriverLicenseFormData(driverLicense = null) {
  if (driverLicense == null) return createEmptyDriverLicense();
  const normalizedDriverLicense = driverLicense || {};

  return {
    ...createEmptyDriverLicense(),
    ...normalizedDriverLicense,
    issued_at: dateValue(normalizedDriverLicense.issued_at),
    valid_to: dateValue(normalizedDriverLicense.valid_to),
    categories: parseCategories(normalizedDriverLicense.categories),
    attachment_ids: attachmentIds(normalizedDriverLicense),
    attachments: Array.isArray(normalizedDriverLicense.attachments)
      ? normalizedDriverLicense.attachments
      : [],
  };
}

// Собирает заполненное ВУ, сохраняя null/отсутствие списка вложений.
export function buildDriverLicensePayload(formData = {}) {
  const driverLicense = formData.driver_license || {};
  const payload = {
    series: stringOrNull(driverLicense.series),
    number: stringOrNull(driverLicense.number),
    issued_at: driverLicense.issued_at || null,
    valid_to: driverLicense.valid_to || null,
    issued_by: stringOrNull(driverLicense.issued_by),
    categories: parseCategories(driverLicense.categories),
    attachment_ids: attachmentIds(driverLicense),
  };

  const hasValues = Object.entries(payload).some(([key, value]) => {
    if (key === "categories") return value.length > 0;
    if (key === "attachment_ids") return (value?.length || 0) > 0;
    return Boolean(value);
  });

  // Существующий документ отправляем и после очистки последнего вложения.
  return driverLicense.id || hasValues ? payload : null;
}

function attachmentIds(driverLicense = {}) {
  if (
    Object.prototype.hasOwnProperty.call(driverLicense, "attachment_ids") &&
    driverLicense.attachment_ids == null
  ) {
    return driverLicense.attachment_ids;
  }
  if (Array.isArray(driverLicense.attachment_ids)) {
    return [...driverLicense.attachment_ids];
  }

  if (Array.isArray(driverLicense.attachments)) {
    return driverLicense.attachments.map((attachment) => attachment.id).filter(Boolean);
  }

  return undefined;
}

function stringOrNull(value) {
  const normalized = String(value || "").trim();
  return normalized || null;
}

function parseCategories(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

function dateValue(value) {
  if (!value) return "";

  return String(value).slice(0, 10);
}
